<div class="row">
     <div labelTextInput [class]="(isPartiSearch && isPersonaFisica())  ? 'col-sm-4 bloccodati':'col-sm-3 bloccodati'" [typeLabel]="'text'" [labelInput]="'Cognome e nome'"
          [valueInput]="(controparte.parte?.cognome ? controparte.parte?.cognome : '')+(controparte.parte?.nome ? (' ' + controparte.parte?.nome) : '')">
     </div>
     <div labelTextInput [class]="(isPartiSearch && isPersonaFisica())  ? 'col-sm-4 bloccodati':'col-sm-2 bloccodati'" [typeLabel]="'text'" [labelInput]="'Tipo persona'"
          [valueInput]="controparte.parte?.tipoPersona?controparte.parte?.tipoPersona.label:''"></div>
     <ng-template [ngIf]="isPartiSearch">
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" *ngIf="isPersonaFisica() && isFascicoloSanitario"
               [typeLabel]="'boolean'" [labelInput]="'Vivente'"
               [valueInput]="controparte.parte?.vivente"></div>
          <div labelTextInput [class]="(isPersonaFisica()) ? 'col-xs-12 col-sm-4 bloccodati':'col-xs-12 col-sm-2 bloccodati'" [typeLabel]="'boolean'" [labelInput]="'Dipendente'"
               [valueInput]="controparte.parte?.dipendente"></div>
          <div labelTextInput *ngIf="!controparte"[class]="(isPersonaFisica()) ? 'col-xs-12 col-sm-4 bloccodati':'col-xs-12 col-sm-2 bloccodati'" [typeLabel]="'text'" [labelInput]="'Matricola'"
               [valueInput]="controparte.parte?.matricola"></div>
          <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice fiscale'"
               [valueInput]="controparte.parte?.codiceFiscale"></div>
          <div labelTextInput class="col-xs-12 col-sm-2 bloccodati" style="padding: 0px 5px 0px 5px;" [typeLabel]="'text'" [labelInput]="'Sesso'"  *ngIf="isPersonaFisica()" [valueInput]="controparte.parte?.sesso"></div>
     </ng-template>





     <ng-template [ngIf]="!isPartiSearch">
          <div labelTextInput class="col-xs-12 col-sm-7 bloccodati" [typeLabel]="'checklist'"
               [labelInput]="'Ambito di competenza'" [checkListValue]="controparte.parte?.ambitiCompetenza"></div>
     </ng-template>
</div>
<ng-template [ngIf]="!isPartiSearch">
     <div class="row">
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice fiscale'"
               [valueInput]="controparte.parte?.codiceFiscale?controparte.parte?.codiceFiscale:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Convenzione'"
               [valueInput]="controparte.parte?.convenzione"></div>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tariffa'"
               [valueInput]="(controparte.parte?.tariffa|euro)+' &euro;'"></div>
     </div>
</ng-template>
<div class="row">
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Ragione sociale'"
          [valueInput]="controparte.parte?.ragioneSociale?controparte.parte?.ragioneSociale:''"></div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Partita Iva'"
          [valueInput]="controparte.parte?.partitaIva?controparte.parte?.partitaIva:''"></div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'CF Rappresentante Legale'"
          [valueInput]="controparte.parte?.codiceFiscaleRappresentanteLegale ? controparte.parte?.codiceFiscaleRappresentanteLegale : ''">
     </div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo societ&agrave;'"
          [valueInput]="controparte.parte?.tipoSocieta?controparte.parte?.tipoSocieta.label:''"></div>
</div>

<div class="row">
  <div labelTextInput class="col-xs-12 col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Nominativo originale'"
       [valueInput]="controparte.parte?.nominativoOriginale ? controparte.parte?.nominativoOriginale : ''">
  </div>
</div>

<div class="row container_fieldset" *ngIf="!hideOtherData">
     <div class="col-sm-12 col-xs-12">
          <fieldset class="form-group">
               <legend>Nascita <span class="sr-only">anagrafica</span></legend>
               <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'date'" [labelInput]="'Data'"
                    [valueInput]="controparte.parte?.dataNascita"></div>
               <div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'" [labelInput]="'Comune'"
                    [valueInput]="controparte.parte?.comuneNascita?controparte.parte?.comuneNascita.label:''"></div>
               <div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'" [labelInput]="'Provincia'"
                    [valueInput]="controparte.parte?.provinciaNascita?controparte.parte?.provinciaNascita.label:''"></div>
          </fieldset>
     </div>
</div>
<div class="row container_fieldset" *ngIf="!hideOtherData">
     <div class="col-sm-12 col-xs-12">
          <fieldset class="form-group">
               <legend>Residenza <span class="sr-only">anagrafica</span></legend>
               <div labelTextInput class="col-sm-8 bloccodati" [typeLabel]="'text'" [labelInput]="'Indirizzo'"
                    [valueInput]="controparte.parte?.indirizzo?controparte.parte?.indirizzo:''"></div>
               <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cap'"
                    [valueInput]="controparte.parte?.cap?controparte.parte?.cap:''"></div>
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Comune'"
                    [valueInput]="controparte.parte?.comuneResidenza?controparte.parte?.comuneResidenza.label:''"></div>
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Provincia'"
                    [valueInput]="controparte.parte?.provinciaResidenza?controparte.parte?.provinciaResidenza.label:''">
               </div>
          </fieldset>
     </div>
</div>
<div class="row container_fieldset" *ngIf="false"> <!--!hideOtherData  (da mettere nel'IF)-->
     <div class="col-sm-12 col-xs-12">
          <fieldset class="form-group">
               <legend>Dati profilo professionale</legend>
               <!-- <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Figura professionale'"
                    [valueInput]="controparte.parte?.figuraProfessionale?controparte.parte?.figuraProfessionale.label:''">
               </div> -->
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Ordine'"
                    [valueInput]="controparte.parte?.ordine ? controparte.parte?.ordine : ''"></div>
               <!--<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; iscrizione albo'"
                    [valueInput]="controparte.parte?.numeroIscrizione ? controparte.parte?.numeroIscrizione : ''"></div>-->
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data iscrizione Albo'"
                    [valueInput]="controparte.parte?.dataIscrizioneAlbo ? controparte.parte?.dataIscrizioneAlbo : ''"></div>
               <div class="row">
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice Cassa'"
                         [valueInput]="controparte.parte?.codiceMeccanografico ? controparte.parte?.codiceMeccanografico : ''">
                    </div>
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data iscrizione Cassa'"
                         [valueInput]="controparte.parte?.dataIscrizioneAlbo ? controparte.parte?.dataIscrizioneCassa : ''"></div>
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Status'"
                         [valueInput]="controparte.parte?.statoAT ? controparte.parte?.statoAT : ''"></div>
               </div>
               <div class="row" style="padding: 10px;" *ngIf="controparte.societa.length > 0">
                    <table class="table-striped table aggiunta_classificazione table_fondo_oneri">
                         <caption class="sr-only">Tabella anagrafiche società</caption>
                         <thead>
                              <th style="width: 20%;">Società</th>
                              <th style="width: 20%;">Carica</th>
                              <th style="width: 10%;">Dal</th>
                              <th style="width: 10%;">Al</th>
                              <th style="width: 15%;">Incarico Rimosso</th>
                              <th style="width: 15%;">% Partecipazione</th>
                              <th style="width: 10%;">Codice ateco</th>
                              <th></th>
                         </thead>
                         <tbody>
                              <!-- <tr *ngFor="let societa of controparte.societa"> -->
                              <tr *ngFor="let societa of controparte.societa">
                                   <td>{{societa.societa}}</td>
                                   <td>{{societa.carica}}</td>
                                   <td>{{societa.dataDal | dateformatter: 'DD/MM/YYYY'}}</td>
                                   <td>{{societa.dataAl | dateformatter: 'DD/MM/YYYY'}}</td>
                                   <td>{{societa.incaricoRimosso}}</td>
                                   <td>{{societa.percPartecipazione ? societa.percPartecipazione + '%' : '-'}}</td>
                                   <td>{{societa.codiceAteco ? societa.codiceAteco : ''}}</td>
                                   <td><a class="dropdown-toggle" style="cursor: pointer; color: #0867b4;"
                                             data-title="dettaglio" (click)="infoSocietaModal.show(societa)">
                                             <span class="glyphicon glyphicon-info-sign"></span>
                                        </a>
                                   </td>
                              </tr>
                         </tbody>
                    </table>
                    <tlf-info-societa-modal #infoSocietaModal></tlf-info-societa-modal>
               </div>
          </fieldset>
     </div>
</div>
<div class="row container_fieldset" *ngIf="!hideOtherData">
     <div class="col-sm-12 col-xs-12">
          <fieldset class="form-group">
               <legend>Contatti<span class="sr-only">anagrafica</span></legend>
               <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Telefono'"
                    [valueInput]="controparte.parte?.telefono?controparte.parte?.telefono:''"></div>
               <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cellulare'"
                    [valueInput]="controparte.parte?.cellulare?controparte.parte?.cellulare:''"></div>
               <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N&#176; fax'"
                    [valueInput]="controparte.parte?.fax?controparte.parte?.fax:''"></div>
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Email'"
                    [valueInput]="controparte.parte?.email?controparte.parte?.email:''"></div>
               <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Pec'"
                    [valueInput]="controparte.parte?.pec?controparte.parte?.pec:''"></div>
          </fieldset>
     </div>
</div>
<div class="row">
     <div class="col-sm-12 bloccodati">
          <p>
               <label class="col-sm-12">Note</label> <span class="longtext">{{ controparte.parte?.note ?
                    controparte.parte?.note : "" }}</span>
          </p>
     </div>
</div>
